import React from 'react';

import { useEffect, useState } from 'react';

import { useNavigate, Link } from 'react-router-dom';

import { Container, FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import { Badge } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Card } from 'react-bootstrap';

import ResourceStore from '../../../stores/ResourceStore';
import MediaUsageGoalStore from '../../../stores/MediaUsageGoalStore';
import ResourceTypeStore from '../../../stores/ResourceTypeStore';

import './style.css';

const PortalResourceListPage = () => {
    const navigate = useNavigate();

    const resourceStore = ResourceStore((state) => state);
    const mediaUsageGoalStore = MediaUsageGoalStore((state) => state);
    const resourceTypeStore = ResourceTypeStore((state) => state);

    const [selectedResourceTypes, setSelectedResourceTypes] = useState([]);
    const [selectedMediaUsageGoals, setSelectedMediaUsageGoals] = useState([]);
    const [searchString, setSearchString] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(9);
    const [lastPage, setLastPage] = useState(1);
    const [totalResults, setTotalResults] = useState(0);

    useEffect(() => {
        mediaUsageGoalStore.loadAll();
        resourceTypeStore.loadAll();
        const success = (res) => {
            setLastPage(res.lastPage);
            setTotalResults(res.totalResults);
        };

        resourceStore.loadAll(pageSize, currentPage, success);
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    var tableRows = null;

    const handlePageChange = (page) => {
        // change page on click
        if (page >= 1 && page <= lastPage) {
            setCurrentPage(page);

            const success = (res) => {
                setLastPage(res.lastPage);
                setTotalResults(res.totalResults);
            };

            resourceStore.loadAll(pageSize, page, success);
        }
    };

    const handlePageSizeChange = (size) => {
        setPageSize(Number(size.target.value));
        setCurrentPage(1);

        const success = (res) => {
            console.log(res);

            setLastPage(res.lastPage);
            setTotalResults(res.totalResults);
        };

        resourceStore.loadAll(Number(size.target.value), 1, success);
    };

    if (null != resourceStore.portalResources) {
        tableRows = resourceStore.portalResources.map(function (item, i) {
            return (
                <tr key={'portalResource-' + i}>
                    <td>
                        <a
                            href="#"
                            onClick={() => {
                                navigate('edit/' + item.id);
                            }}
                        >
                            {i + 1}
                        </a>
                    </td>
                    <td>
                        <a
                            href="#"
                            onClick={() => {
                                navigate('edit/' + item.id);
                            }}
                        >
                            {item.id}
                        </a>
                    </td>
                    <td>
                        <div
                            onClick={() => {
                                navigate('edit/' + item.id);
                            }}
                        >
                            {item.title}
                        </div>
                    </td>
                </tr>
            );
        });
    }

    var mediaUsageGoals = mediaUsageGoalStore.mediaUsageGoals;
    var resourceTypes = resourceTypeStore.resourceTypes;

    const renderPagination = () => {
        const pages = [];
        const maxPagesToShow = 5; // Number of pages to show in the middle
        const startPage = Math.max(2, currentPage - 2); // Start from the second page
        const endPage = Math.min(lastPage - 1, currentPage + 2); // End at the second-to-last page

        // Add the first page button
        pages.push(
            <a
                key={1}
                href="#"
                className={`page-link ${currentPage === 1 ? 'active' : ''}`}
                onClick={() => handlePageChange(1)}
            >
                1
            </a>,
        );

        // Add ellipsis if starting page is greater than 2
        if (startPage > 2) {
            pages.push(
                <span key="start-ellipsis" className="page-ellipsis">
                    ...
                </span>,
            );
        }

        // Add the pages in the range (two before current page to two after)
        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <a
                    key={i}
                    href="#"
                    className={`page-link ${i === currentPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </a>,
            );
        }

        // Add ellipsis if ending page is less than lastPage - 1
        if (endPage < lastPage - 1) {
            pages.push(
                <span key="end-ellipsis" className="page-ellipsis">
                    ...
                </span>,
            );
        }

        // Add the last page button if there are more than one page
        if (lastPage > 1) {
            pages.push(
                <a
                    key={lastPage}
                    href="#"
                    className={`page-link ${currentPage === lastPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(lastPage)}
                >
                    {lastPage}
                </a>,
            );
        }

        return (
            <div className="pagination" id="pagination">
                <a
                    href="#"
                    id="prev"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </a>
                {pages}
                <a
                    href="#"
                    id="next"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === lastPage}
                >
                    Next
                </a>
            </div>
        );
    };

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('create');
                        }}
                    >
                        Create PortalResource
                    </Button>
                </Col>
            </Row>

            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Card>
                        <div style={{ margin: '10px' }}>
                            <h4>Filter</h4>
                        </div>

                        <ul>
                            {' '}
                            Media Usage Goals:
                            <ul>
                                {' '}
                                {null == mediaUsageGoals
                                    ? null
                                    : mediaUsageGoals.map((goal, i) => {
                                          const isSelected =
                                              -1 !=
                                              selectedMediaUsageGoals.indexOf(
                                                  goal.goal,
                                              );

                                          return (
                                              <Badge
                                                  key={'mediaUsageGoal-' + i}
                                                  bg={
                                                      isSelected
                                                          ? 'primary'
                                                          : 'secondary'
                                                  }
                                                  style={{ margin: '4px' }}
                                                  onClick={() => {
                                                      if (isSelected) {
                                                          const goalIndex =
                                                              selectedMediaUsageGoals.indexOf(
                                                                  goal.goal,
                                                              );
                                                          const newArray = [
                                                              ...selectedMediaUsageGoals,
                                                          ];
                                                          newArray.splice(
                                                              goalIndex,
                                                              1,
                                                          );

                                                          setSelectedMediaUsageGoals(
                                                              newArray,
                                                          );
                                                      } else {
                                                          setSelectedMediaUsageGoals(
                                                              selectedMediaUsageGoals.concat(
                                                                  goal.goal,
                                                              ),
                                                          );
                                                      }
                                                  }}
                                              >
                                                  {goal.goal}
                                              </Badge>
                                          );
                                      })}
                            </ul>
                        </ul>

                        <ul>
                            {' '}
                            Resource Types:
                            <ul>
                                {' '}
                                {null == resourceTypes
                                    ? null
                                    : resourceTypes.map((resourceType, i) => {
                                          const isSelected =
                                              -1 !=
                                              selectedResourceTypes.indexOf(
                                                  resourceType.name,
                                              );

                                          return (
                                              <Badge
                                                  key={'resourceType-' + i}
                                                  bg={
                                                      isSelected
                                                          ? 'success'
                                                          : 'secondary'
                                                  }
                                                  style={{ margin: '4px' }}
                                                  onClick={() => {
                                                      if (isSelected) {
                                                          const resourceTypeIndex =
                                                              selectedResourceTypes.indexOf(
                                                                  resourceType.name,
                                                              );
                                                          const newArray = [
                                                              ...selectedResourceTypes,
                                                          ];
                                                          newArray.splice(
                                                              resourceTypeIndex,
                                                              1,
                                                          );

                                                          setSelectedResourceTypes(
                                                              newArray,
                                                          );
                                                      } else {
                                                          setSelectedResourceTypes(
                                                              selectedResourceTypes.concat(
                                                                  resourceType.name,
                                                              ),
                                                          );
                                                      }
                                                  }}
                                              >
                                                  {resourceType.name}
                                              </Badge>
                                          );
                                      })}
                            </ul>
                            <ul>
                                <li>
                                    <FormGroup
                                        key={'form-full-text'}
                                        controlId={'form-full-text'}
                                    >
                                        <FormLabel>
                                            Full Text
                                            <span className="text-danger"></span>
                                        </FormLabel>

                                        <FormControl
                                            type="text"
                                            value={searchString}
                                            onChange={(e) => {
                                                setSearchString(e.target.value);
                                            }}
                                        />
                                    </FormGroup>
                                </li>
                            </ul>
                        </ul>

                        <Button
                            style={{
                                float: 'right',
                                margin: '14px',
                                width: '200px',
                            }}
                            onClick={() => {
                                resourceStore.search({
                                    mediaUsageGoals: selectedMediaUsageGoals,
                                    resourceTypes: selectedResourceTypes,
                                    fullTextSectionSearchString: [searchString],
                                });
                            }}
                        >
                            Apply Filter
                        </Button>
                    </Card>

                    <Table
                        striped
                        bordered
                        condensed="true"
                        hover
                        style={{ marginTop: '14px' }}
                    >
                        <thead>
                            <tr>
                                <th>Number</th>
                                <th>PortalResource ID</th>
                                <th>PortalResourcename</th>
                            </tr>
                        </thead>

                        <tbody>{tableRows}</tbody>
                    </Table>
                    {renderPagination()}

                    <select
                        onChange={(size) => handlePageSizeChange(size)}
                        value={pageSize}
                    >
                        <option value={9}>9</option>
                        <option value={18}>18</option>
                        <option value={32}>32</option>
                    </select>
                    <div style={{ margin: '10px 0' }}>
                        Found {totalResults} results
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default PortalResourceListPage;
